// @flow

import React, { Component } from 'react';
import styled from 'styled-components';

import Page from './Page';
import type { PageProps } from './EmptyPage';
import { IsLargeScreen } from './Media';

import { breakpoint } from '../utils/responsive';
import { row, column } from '../utils/layout';

type Props = PageProps & {
  smallImage: string,
  largeImage: string,
  largeImageHeight?: string,
};

const Row = styled.div`
  ${row()};
  height: 100%;

  ${breakpoint('large')`
    flex-direction: row-reverse;
  `};
`;

const LeftColumn = styled.div`
  ${column(12, 12, 6)};
  display: flex;
`;

//Need this to make stuff wrap correct in IE
const LeftColumnContent = styled.div`
  flex-direction: column;
  display: flex;
  flex: 1 0;
`;

const RightColumn = styled.div`
  ${column(12, 12, 6)};
  align-items: center;
  display: flex;
  justify-content: center;
  margin-top: -6px;
  padding-left: 0px;
  padding-right: 0px;

  ${breakpoint('medium')`
    padding-left: 12px;
    padding-right: 12px;
  `};

  ${breakpoint('large')`
    padding-left: 0px;
    padding-right: 12px;
    margin-bottom: -6px;
  `};
`;

const Image = styled.img`
  width: 100%;
  object-fit: contain;
  object-position: 50% 50%;
`;

const LargeImage = styled.img`
  width: 100%;
  ${(props) => (props.ImageHeight ? 'height:' + props.ImageHeight : '')};
`;

class DoublePage extends Component<Props> {
  render() {
    const { children, smallImage, largeImage, largeImageHeight, ...props } =
      this.props;

    return (
      <Page {...props}>
        <Row>
          <RightColumn>
            <IsLargeScreen>
              {(match) =>
                match ? (
                  <LargeImage ImageHeight={largeImageHeight} src={largeImage} />
                ) : (
                  <Image src={smallImage} />
                )
              }
            </IsLargeScreen>
          </RightColumn>
          <LeftColumn>
            <LeftColumnContent>{children}</LeftColumnContent>
          </LeftColumn>
        </Row>
      </Page>
    );
  }
}

export default DoublePage;
